import { render, staticRenderFns } from "./CampaignListAdd.vue?vue&type=template&id=4e38c887"
import script from "./CampaignListAdd.vue?vue&type=script&lang=js"
export * from "./CampaignListAdd.vue?vue&type=script&lang=js"
import style0 from "./CampaignListAdd.vue?vue&type=style&index=0&id=4e38c887&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports